import { styled } from '../muiReexports';
export const InnerContainer = styled('div', { shouldForwardProp: (prop) => prop !== 'overflowAuto' && prop !== 'hidden' })(({ overflowAuto, hidden }) => ({
    display: hidden ? 'none' : 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: overflowAuto ? 'auto' : undefined,
}));
